import { Search } from "./Search.model"

export class ProjectCost {
    projects? = new Array<String | Number>()
    companyGroups? = new Array<String | Number>()
    clients? = new Array<any | Number>()
    findResults: Search
    projectType: Number;
    totalValuePayment: String;
}



// WEBPACK FOOTER //
// ./src/app/models/ProjectCost.model.ts